export default {
  data() {
    return {}
  },
  methods : {},
  computed: {
    interactiveMapsProvider() {
      return this.AppConfig?.Maps?.InteractiveMapsProvider || null
    },
    staticMapsProvider() {
      return this.AppConfig?.Maps?.StaticMapsProvider || null
    },
    geocodeProvider() {
      return this.AppConfig?.Maps?.GeocodeProvider || this.interactiveMapsProvider || this.staticMapsProvider || null
    }
  }
}
